import TimePicker from 'react-time-picker';
import styled from 'styled-components';

export const StyledTimeInput = styled(TimePicker)`
  .react-time-picker__wrapper {
    padding: 0 1.5rem;
    height: 3.8rem;
    background-color: white;
    border-radius: 20px;
  }

  .react-time-picker--disabled {
    color: #000000;
  }

  .react-time-picker__inputGroup__input {
    color: #000000;
  }

  .react-time-picker__inputGroup__leadingZero {
    color: #000000;
  }

  .react-time-picker__inputGroup__divider {
    color: #000000;
  }
`;
